<template>
    <div>
        <company-route-tabs
            v-if="isSuperAdmin"
            :company-id="companyId"
        ></company-route-tabs>
        <company-cloudcanteen-form
            :company-id="companyId"
        ></company-cloudcanteen-form>
    </div>
</template>

<script>
import CompanyCloudcanteenForm from '@/components/pages/companyCloudcanteens/Form'
import CompanyRouteTabs from '@/components/pages/companies/RouteTabs'
import dirtyForm from '@/components/mixins/dirtyForm'
import AuthMixin from '@/components/mixins/AuthMixin'

export default {
    components: { CompanyCloudcanteenForm, CompanyRouteTabs },
    mixins: [dirtyForm, AuthMixin],

    props: {
        companyId: {
            type: [String, Number],
            default: null,
        },
    },
}
</script>
